import { css } from 'styled-components';

import { THIN_SCROLLBAR } from './scrollbar';

/**
 * Terminal-style "mono box" chrome shared by fenced code, plain-text
 * fallback tables, and approval-request command previews: any raw
 * agent/system output that isn't rendered through a dedicated UI widget
 * defaults to this look, matching the app's raw-output aesthetic.
 *
 * Covers the chrome (font, background, border, scroll) plus an EXPLICIT
 * text color: the package renders into host pages whose global styles
 * routinely target `pre`/`code` (docs stylesheets, syntax themes), and any
 * element-level host rule beats inherited color — a light-theme host
 * `pre { color: #24292e }` turned fenced code near-invisible on the dark
 * box. Pinning the color here keeps the theming contract (it's still the
 * host's variable) while making inheritance irrelevant.
 * Font-size/line-height/margin/padding vary by call site (e.g. an approval
 * card's command preview reads smaller than a chat message's fenced code),
 * so those stay local to each usage.
 */
export const MONO_BOX = css`
  font-family: var(--font-mono, monospace);
  color: var(--text-primary);
  background: rgba(var(--color-lightest), 0.06);
  border: 1px solid var(--border-color);
  border-radius: 4px;
  overflow-x: auto;
  ${THIN_SCROLLBAR}
`;
